<template>
  <footer>
    <div class="container">
        <div class="top-container">
            <div class="left-side">
                <div class="item-block" v-for="(item, index) in infoList" :key="index">
                    <div class="block-title">{{item.title}}</div>
                    <div class="item">
                        <div class="icon"><i class="el-icon-phone"></i></div>
                        <div class="detail">
                            <div class="sub-t">联系电话</div>
                            <div class="content">{{item.connection}}</div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="icon"><i class="el-icon-eleme"></i></div>
                        <div class="detail">
                            <div class="sub-t">邮箱</div>
                            <div class="content">{{item.email}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right-side">
                <div class="side-title">在线留言</div>
                <el-form ref="form" class="form">
                    <el-row>
                        <el-col :span="10">
                            <el-form-item :required="true" label="您的姓名">
                                <input type="text" v-model="form.userName" placeholder="请输入您的姓名">
                            </el-form-item>
                        </el-col>
                        <el-col :span="10" :offset="3">
                            <el-form-item :required="true" label="联系方式">
                                <input type="text" v-model="form.contactHone" placeholder="请输入您的手机号">
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-form-item label="留言">
                            <textarea v-model="form.intro" name="" id="" cols="30" rows="10" placeholder="留下您的问题，我们会有专业的服务人员为您解答"></textarea>
                        </el-form-item>
                    </el-row>
                    <el-row type="flex" justify="end">
                        <el-button class="sub-btn" @click="submit"> 提 交 </el-button>
                    </el-row>
                </el-form>
            </div>
        </div>
        <div class="center-container">
            <div class="row1">
                <div class="item-block" v-for="(item, index) in infoList2" :key="index">
                    <div class="block-title">{{item.title}}</div>
                    <a v-for="(a, index) in item.list" :key="index">{{a.title}}</a>
                </div>
                <div class="img-list">
                    <img v-for="item in imgList" :src="item" alt="">
                </div>
            </div>
            <div class="row2">
                <span>友情链接：</span>
                <template v-for="(item, index) in friedsLinks">
                    <span class="link">{{item.title}}</span>
                    <span class="little-line"></span>
                </template>
            </div>
        </div>
        <div class="bottom-container">
            copynight@ 2012-2019 北京中健时代教育科技有限责任公司 SouMate All Rights Reserved 京ICP备19000971号-1 京公网安备31010702004489号
        </div>
    </div>
  </footer>
</template>

<script>
import { addFeedback } from '@/api/home'
export default {
  name: "footer",
  data() {
    return {
        infoList: [
            {
                title: "商务合作",
                connection: "400-082-0021",
                email: "youerduoyujiaoyu@163.com"
            },
            {
                title: "招聘相关",
                connection: "010-60638099",
                email: "jtgs2935@163.com"
            },
        ],
        infoList2: [
            {
                title: "用户协议",
                list: [
                    {
                        title: '免责声明',
                        url: ''
                    },
                    {
                        title: '用户协议',
                        url: ''
                    },
                ]
            },
            {
                title: "获得帮助",
                list: [
                    {
                        title: '用户反馈',
                        url: ''
                    },
                    {
                        title: '帮助中心',
                        url: ''
                    },
                ]
            },
            {
                title: "关于我们",
                list: [
                    {
                        title: '倡导单位：中国关心下一代工作委员会健康体育发展中心',
                        url: ''
                    },
                    {
                        title: '执行单位：北京中健时代教育科技有限责任公司',
                        url: ''
                    },
                    {
                        title: '研发单位：中国管理科学研究院学术委员会新语境教育研究中心',
                        url: ''
                    },
                ]
            },
        ],
        imgList: [
            require('../assets/img/douyin.png'), 
            require('../assets/img/weixin.png'), 
        ],
        friedsLinks: [
            {
                title: "中国关心下一代委员会健体中心",
                url: "",
            },
            {
                title: "中国民办教育协会学前教育专业委员会",
                url: "",
            },
            {
                title: "中国成人教育协会培训工作委员会",
                url: "",
            },
            {
                title: "中国管理科学研究院学术委员会",
                url: "",
            },
            {
                title: "北京联合国教科文组织协会",
                url: "",
            },
        ],
        form: {
            userName: "",
            contactHone: "",
            intro: ""
        }
    };
  },
  created() {
    // console.log(this.$refs['form'])
  },
  methods: {

    submit() {
        console.log(this.form)

        addFeedback({
            ...this.form
        }).then(res =>{
            this.form = {
                userName: '',
                contactHone: '',
                intro: ''
            }
            this.$message({
                message: '反馈成功',
                type: 'success'
            });
        })
    },
    
    go(params) {
      console.log(params, "jiajaiajia");
      if (params === 1) {
        //用户协议
        window.open(
          `https://view.officeapps.live.com/op/view.aspx?src=https://multilingual-education.oss-cn-beijing.aliyuncs.com/homeFile/freeText.doc`
        );
      } else if (params === 2) {
        //免责声明
        window.open(
          `https://view.officeapps.live.com/op/view.aspx?src=https://multilingual-education.oss-cn-beijing.aliyuncs.com/homeFile/userText.docx`
        );
      } else if (params === 3) {
        this.$router.push({
          name: "aboutUs",
          params: {
            id: 4,
          },
        });
      } else if (params === 4) {
        this.$router.push({
          name: "aboutUs",
          params: {
            id: 3,
          },
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.align-center{
    display: flex;
    align-items: center;
}
.flex-center{
    display: flex;
    align-items: center;
    justify-content: center;
}
footer{
    width: 100%;
    background-color: #262A35;
    color: #FFF;
    margin-top: 105px;
    .container{
        width: 1200px;
        margin: 0 auto;
        .top-container{
            display: flex;
            // align-items: center;
            justify-content: space-between;
            // height: 476px;
            box-sizing: border-box;
            padding: 40px 0;
            border-bottom: 1px solid #353943;
            .left-side{
                height: 100%;
                .item-block{
                    margin-bottom: 40px;
                    .block-title{
                        height: 26px;
                        font-size: 20px;
                        font-family: MicrosoftYaHei;
                        line-height: 26px;
                    }
                    .item{
                        .align-center();
                        margin-top: 24px;
                        .icon{
                            width: 45px;
                            height: 45px;
                            border-radius: 50%;
                            border: 1px solid #FFFFFF;
                            font-size: 26px;
                            .flex-center();
                        }
                        .detail{
                            margin-left: 15px;
                            .sub-t{
                                height: 17px;
                                font-size: 12px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #CCCCCC;
                                line-height: 17px;
                            }
                            .content{
                                height: 25px;
                                font-size: 18px;
                                font-family: PingFangSC-Semibold, PingFang SC;
                                font-weight: 600;
                                color: #FFFFFF;
                                line-height: 25px;
                            }
                        }
                    }
                }
            }
            .right-side{
                width: 621px;
                .side-title{
                    height: 26px;
                    font-size: 20px;
                    font-family: MicrosoftYaHei;
                    color: #FFFFFF;
                    line-height: 26px;
                }
                .form{
                    margin-top: 15px;
                    input{
                        width: 287px;
                        height: 48px;
                        background: #FFFFFF;
                        border-radius: 2px;
                        line-height: 48px;
                        padding-left: 16px;
                    }
                    textarea{
                        width: 621px;
                        height: 128px;
                        background: #FFFFFF;
                        border-radius: 2px;
                        box-sizing: border-box;
                        padding: 11px 16px;
                    }
                    .sub-btn{
                        width: 160px;
                        height: 48px;
                        background: #2593DD;
                        border-radius: 2px;
                        font-size: 16px;
                        font-family: MiSans-Medium, MiSans;
                        font-weight: 500;
                        color: #FFFFFF;
                        border: none;
                    }
                }
            }
        }

        .center-container{
            box-sizing: border-box;
            padding: 40px 0 16px;
            width: 100%;
            position: relative;
            border-bottom: 1px solid #353943;
            .row1{
                a{
                    display: block;
                }
                display: flex;
                width: 100%;
                .item-block{
                    margin-right: 100px;
                    .block-title{
                        font-size: 16px;
                        font-family: Helvetica;
                        color: #FFFFFF;
                        margin-bottom: 24px;
                    }
                    a{
                        height: 17px;
                        font-size: 12px;
                        font-family: Helvetica;
                        color: #BCBCBC;
                        line-height: 14px;
                        margin-bottom: 10px;
                    }

                }
                .img-list{
                    img{
                        width: 134px;
                        height: 138px;
                        margin-left: 46px;
                    }
                }
            }
            .row2{
                width: 1200px;
                height: 20px;
                font-size: 12px;
                font-family: Helvetica;
                color: #D5D5D5;
                line-height: 20px;
                margin-top: 55px;
                display: flex;
                align-items: center;
                justify-content: center;
                :last-child{
                    display: none;
                }
                .little-line{
                    height: 10px;
                    border-right: 1px solid #AAA;
                    margin: 0 10px;
                }
            }
        }

        .bottom-container{
            box-sizing: border-box;
            text-align: center;
            width: 1200px;
            font-size: 12px;
            font-family: Helvetica;
            color: #8E8E8E;
            line-height: 20px;
            padding: 10px 0 17px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/footer-v2.vue